
import 'quasar/dist/quasar.css'
import '@quasar/extras/material-icons/material-icons.css'

import * as quasarComponents from 'quasar'

// To be used on app.use(Quasar, { ... })
export default {
  components: quasarComponents
}